module.exports = __webpack_public_path__ + "img/polygon.7646757c.svg";